import Service from "../../../service/api.js"

const ForgotModule = {
    // namespaced: true,
    state: {
        dialogForgotOTPHolder: false,
        secret: "",
        dialogSetNewPassword: false,
        dialogError: false,
        invalidEmailWarning: false,
        showResetPasswordSuccessModal:false,
        loading: false
    },

    //มีไว้ setting
    mutations: {
        dialogForgotOTPHolderMutation(state, res) {
            state.dialogForgotOTPHolder = true
            state.dialogSetNewPassword = false
            state.secret = res.data.secret
        },
        setLoading(state, val){
            state.loading = val
        },
        closeDialog(state) {
            state.dialogForgotOTPHolder = false
        },
        closeDialog2(state) {
            state.dialogSetNewPassword = false
        },
        showDialog(state) {
            state.dialogSetNewPassword = true
        },
        showDialogError(state) {
            state.dialogError
        },
        disableInvalidEmailWarning(state) {
            state.invalidEmailWarning = false
        },
        showInvalidEmail(state) {
            state.invalidEmailWarning = true
        },
        closeResetPasswordSuccessModal(state) {
            state.showResetPasswordSuccessModal = false
        },
        setShowingResetPasswordSuccessModal(state){
            state.showResetPasswordSuccessModal = true
        },
    },

    actions: {

        confirmForgotOTPaction({ commit }, payload) {
            commit('setLoading', true)
            Service.onForgotPassword(payload).then((res) => {
                commit('dialogForgotOTPHolderMutation', res)
            }).catch((err) => {
                commit('closeDialog')
                commit('showInvalidEmail')
                // alert("Error : Your OTP doesn't match, please re-enter your OTP")
            }).finally(() => {
                commit('setLoading', false)
            })
        },

        onVerifyForgotAction({ commit }, payload) {
            Service.onVerifyLogin({
                token: payload.token,
                secret: payload.secret
            }).then((res) => {
                commit('closeDialog')
                commit('showDialog')
            }).catch((err) => {
                alert('Error : Your OTP doesn\'t match, please re-enter your OTP')
            })
        },

        onResetPassword({ commit }, payload) {
            Service.onResetPassword(payload).then((res) => {
                commit('closeDialog2')
                commit('setShowingResetPasswordSuccessModal')
                // alert('Succesfully')
                    // commit('closeallDialog')
            }).catch((err) => {
                alert('Reset password fail')
            })
        },
    },

    getters: {
        dialogForgotOTPHolderGetter(state) {
            return state.dialogForgotOTPHolder;
        },
        OTPForgotSecretGetter(state) {
            return state.secret;
        },
        dialogSetNewPasswordGetter(state) {
            return state.dialogSetNewPassword
        },
        dialogSetNewPasswordSecretGetter(state) {
            return state.secret;
        },
        invalidEmailGetter(state) {
            return state.invalidEmailWarning;
        },
        ResetPasswordSuccessStatus(state){
            return state.showResetPasswordSuccessModal
        },
        getOtpLoading(state){
            return state.loading
        }
    },
}
export default ForgotModule